import { ReactComponent as NimbusUnoLogo } from '../assets/NimbusUnoLogo.svg';
import { ReactComponent as VaultIcon } from '../assets/VaultLoginPage/VaultLogo.svg';

const NimbusConfig = {
  ROUTE: '/product-login-nimbus',
  ICON: NimbusUnoLogo,
  DISPLAY_NAME: 'NIMBUS UNO',
};

const VaultConfig = {
  ROUTE: '/product-login-vault',
  ICON: VaultIcon,
  DISPLAY_NAME: 'MRM VAULT',
};

export { NimbusConfig, VaultConfig };
